export const autocomplete = {
    aria: {
        createNewActionLabel: (searchText) => `Create "${searchText}"`,
    },
};
//# sourceMappingURL=autocomplete.js.map